import React from 'react';
import { Link } from '@fluentui/react-components';
import { createSafeUrlProps } from '../../utils/validation/urlSanitization';

interface SafeLinkProps {
  url?: string | null;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
  'aria-label'?: string;
}

const SafeLink = ({ url, children, ...linkProps }: SafeLinkProps): JSX.Element | null => {
  if (!url) return null;

  const { isValid, href, target, rel } = createSafeUrlProps(url);
  const content = children ?? url;

  if (!isValid) return <>{content}</>;

  return (
    <Link {...linkProps} href={href} target={target} rel={rel}>
      {content}
    </Link>
  );
};

export default SafeLink;
